// extracted by mini-css-extract-plugin
export var dropdownIcon = "_py-6";
export var imgContainer = "_py-3";
export var menuIcon = "_py-5";
export var pillWrapper = "_py-2";
export var pillsContainer = "_py-1";
export var subscriptionCard = "_py-0";
export var subscriptionLogo = "_py-4";